import { Box, Table, TableCell, TableContainer, TableRow } from '@mui/material';
import { FC } from 'react';
import {
	INTEGRATIONS_PLATFORMS_IMG,
	IntegrationsPlatform,
} from 'redux/reducers/integrations/constants';
import { CountryWithFlag } from 'ui/CountryWithFlag';

export type TStep5SquarespaceProps = {
	platform: IntegrationsPlatform;
	APIKey: string;
	storeAddress: string;
	hsCode: string | null;
	selectedCountry: string;
};

export const Step5Squarespace: FC<TStep5SquarespaceProps> = ({
	platform,
	APIKey,
	storeAddress,
	hsCode,
	selectedCountry,
}) => {
	return (
		<TableContainer
			sx={{
				'& .MuiTableCell-root': {
					border: 'none',
				},
			}}
		>
			<Table>
				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						Integration Platform:
					</TableCell>{' '}
					<TableCell sx={{ fontWeight: 'bold', color: '#016193', p: '8px' }}>
						<img
							src={INTEGRATIONS_PLATFORMS_IMG[platform] ?? ''}
							alt=""
							style={{
								height: '20px',
							}}
						/>
					</TableCell>
				</TableRow>
				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						Store Address:
					</TableCell>
					<TableCell sx={{ p: '8px' }}>
						<span style={{ fontWeight: 'bold', color: '#016193' }}>{storeAddress}</span>
					</TableCell>
				</TableRow>
				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						Country:
					</TableCell>
					<TableCell sx={{ fontWeight: 'bold', color: '#016193', p: '8px' }}>
						{selectedCountry && <CountryWithFlag countryCode={selectedCountry} bold />}
					</TableCell>
				</TableRow>
				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						API Key:
					</TableCell>
					<TableCell
						sx={{
							p: '8px',
							maxWidth: '200px',
							height: 'auto',
							overflowWrap: 'break-word',
							wordWreak: 'break-word',
						}}
					>
						<span
							style={{
								fontWeight: 'bold',
								color: '#016193',
							}}
						>
							{APIKey}
						</span>
					</TableCell>
				</TableRow>
				<TableRow>
					<TableCell
						sx={{
							color: '#666',
							p: '8px',
						}}
					>
						HS Code:
					</TableCell>
					<TableCell sx={{ p: '8px' }}>
						<span style={{ fontWeight: 'bold', color: '#016193' }}>{hsCode ?? '\u2014'}</span>
					</TableCell>
				</TableRow>
			</Table>
		</TableContainer>
	);
};
